import classnames from 'classnames'
import { formatToDate } from 'shared/time-utilites'

import TableCell from '@components/TableCell'
import CircleLoader from '@components/CircleLoader'
import Button from '@components/Button'

import { PAYMENT_METHOD_TYPE_PAD } from 'auth/constants'
import { SUBSCRIPTION_MODAL_TAB_INVOICES, SUBSCRIPTION_STATUS_ACTIVE } from 'dashboard-subscriptions/constants'

import styles from './styles.module.scss'

const SubscriptionRow = ({ subscription, selectedType, openSubscription }) => {
    const activeBalance = subscription.balance > 0 && subscription.balance
    const isActiveStatus = subscription.state === SUBSCRIPTION_STATUS_ACTIVE
    const paidWithPad =
        subscription.paymentMethods && subscription.paymentMethods[0]?.paymentMethodType === PAYMENT_METHOD_TYPE_PAD
    const startDate = formatToDate(subscription.effectiveDate)
    const onPayClick = e => {
        e.stopPropagation()
        openSubscription(SUBSCRIPTION_MODAL_TAB_INVOICES)
    }

    const getProductValue = () => {
        if (subscription?.products?.length > 1) {
            return <T>dashboard.subscriptions.label.multiple.products</T>
        }
        return subscription.products[0].productName
    }

    return (
        <>
            {subscription.state === selectedType && (
                <div className={styles.tableRow} onClick={() => openSubscription()}>
                    <TableCell
                        fieldName={<T>dashboard.label.subscription</T>}
                        className={classnames(styles.subscriptionId, 'font-weight-bold')}
                        titleClassName="smallTableHeader">
                        {subscription.id}
                    </TableCell>
                    <TableCell
                        fieldName={<T>dashboard.label.product</T>}
                        className={styles.productName}
                        titleClassName="smallTableHeader">
                        {getProductValue()}
                    </TableCell>
                    <TableCell
                        fieldName={<T>dashboard.label.start.date</T>}
                        className={styles.date}
                        titleClassName="smallTableHeader">
                        {startDate}
                    </TableCell>
                    <TableCell
                        fieldName={<T>dashboard.label.location</T>}
                        className={classnames(styles.location)}
                        titleClassName="smallTableHeader">
                        {subscription?.locationSumary?.name}
                    </TableCell>
                    <TableCell
                        fieldName={isActiveStatus ? <T>dashboard.label.balance.due</T> : <T>dashboard.label.balance</T>}
                        className={classnames(styles.balance, activeBalance ? styles.active : '')}
                        titleClassName="smallTableHeader">
                        {subscription.balance === undefined ? (
                            <CircleLoader size="small" className="mt-2" />
                        ) : (
                            <div className="d-flex align-items-center">
                                <span>${activeBalance || `0.00`}</span>
                                {activeBalance && !paidWithPad && (
                                    <Button size="small" className={styles.payBtn} onClick={onPayClick}>
                                        <T>dashboard.subscriptions.pay</T>
                                    </Button>
                                )}
                            </div>
                        )}
                    </TableCell>
                </div>
            )}
        </>
    )
}

export default SubscriptionRow
